<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 mr-12 p-0 m-r-6'">

    <div class="pl-16 pr-8 py-16 h-52 m-5px" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h3 pr-16 cardHeader">Citas</div>

        <div class="mat-icon-margin">
            <mat-form-field class="example-full-width appointment-datepicker">
                <input matInput [(ngModel)]="currentServiceDate" [matDatepicker]="picker"
                    (dateChange)="getServiceDate(currentServiceDate)" (click)="picker.open()">
                <mat-datepicker-toggle matSuffix [for]="picker" class="s-16 cursor-pointer"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <mat-icon class="s-16 cursor-pointer mat-icon material-icons mat-icon-no-color cal-icon" (click)="previousDate()"
                role="img" aria-hidden="true">arrow_back_ios</mat-icon>
            <mat-icon class="s-16 cursor-pointer cal-icon" (click)="nextDate()" role="img" aria-hidden="true">arrow_forward_ios
            </mat-icon>
        </div>

        <div>
            <button class="calender-btn" mat-raised-button color="accent" (click)='goToagenda()'
                *ngIf="permissionList.indexOf(221)!=-1">Calendario</button>
        </div>
    </div>

    <div class="p-16 simple p-t-0 tbl-appointment2" id="tbl-appointment">
        <div *ngIf="!appointmentService.isLoading">
            <div *ngFor="let serviceData of appointmentService.appointmentServiceData">
                <div class="row">
                    <div class="w-70-citas-b">{{serviceData.companyName}}</div>
                    <div class="w-30-citas-b h-26">{{serviceData.smeFrom | date:"HH:mm"}} - {{ serviceData.smeToTime | date:"HH:mm" }}</div>
                </div>
                <div *ngFor="let taskData of serviceData.tasks">
                    <div class="row pointer clickable" (click)="UserClicked(taskData)">
                        <div class="w-70-citas">
                            {{taskData.apellidos | titlecase }}, {{taskData.tareaNombre | titlecase }}
                        </div>
                        <div class="w-30-citas" *ngIf="taskData.hora != null">{{ taskData.hora | date:"HH:mm" }}</div>
                    </div>

                </div>
            </div>
        </div>

        <div *ngIf="appointmentService.isLoading == true " class="m-auto">
            <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>

    </div>
</div>